var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7405 5.50356C18.5369 4.73801 17.9345 4.13408 17.1681 3.9271C15.7823 3.55566 10.2221 3.55566 10.2221 3.55566C10.2221 3.55566 4.66482 3.55566 3.27619 3.9271C2.51259 4.13124 1.9102 4.73518 1.70374 5.50356C1.33325 6.8929 1.33325 9.79348 1.33325 9.79348C1.33325 9.79348 1.33325 12.6941 1.70374 14.0834C1.90737 14.8489 2.50976 15.4529 3.27619 15.6599C4.66482 16.0313 10.2221 16.0313 10.2221 16.0313C10.2221 16.0313 15.7823 16.0313 17.1681 15.6599C17.9317 15.4557 18.5341 14.8518 18.7405 14.0834C19.111 12.6941 19.111 9.79348 19.111 9.79348C19.111 9.79348 19.111 6.8929 18.7405 5.50356Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44606 12.4672L13.0644 9.79348L8.44606 7.11973V12.4672Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.16fb224a844bd2303081f7203b61724e.svg";
export { ForwardRef as ReactComponent };